// extracted by mini-css-extract-plugin
module.exports = {"csr-B":"B_csr-B__aTVJd","circleWave":"B_circleWave__Pnr3Y"};